import { hideOnClickOutside } from '../utils/utils'
import Collection from "../veritone/Collection";

let collection 	= new Collection();

export default class Modal {
	constructor(element) {
		this.modal 				= element;
		this.modalCloseButtons 	= this.modal.querySelectorAll('.modal--close');
		this.modalOpeners 		= document.querySelectorAll('[data-modal]');
		this.modalShell 		= document.querySelector('#modal__shell');
		this.modalContent		= document.querySelector('#modal__shell .modal__content');
		this.getCloseButtons	= this.getCloseButtons.bind(this);

		if(this.modal && this.modalCloseButtons){
			this.getCloseButtons()
		}

		document.body.addEventListener("click", (event) => {
			if (event.target.closest('[data-modal]')) {
				event.preventDefault();
				//document.body.classList.add('modal--open');
				document.body.classList.remove("loaded");
				let modalOpener = event.target.closest('[data-modal]');
				let formData = new FormData();
				let modalName = modalOpener.dataset.modal;
				let assetID = modalOpener.dataset.assetid;

				formData.append('modalName', modalName);
				if(window.app.smoother) {
					window.app.smoother.paused(true);
				}

				fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
					method: 'POST',
					body: formData,
				})
				.then(response => response.json())
				.then(data => {
					// If a redirect is present, run the redirect, otherwise show the modal
					if(data['redirect']) {
						window.location.replace(data['redirect']);
					} else {
						// Clear modal shell
						this.modalContent.innerHTML = '';

						// Append new data to modal shell
						this.modalContent.insertAdjacentHTML('beforeend', data['modal']);

						// Check for and initialise form page functionality
						let formPages 		= this.modalContent.querySelectorAll('[data-formpage="*"]')
						let formPageButtons = this.modalContent.querySelectorAll('[data-formpagelink]')

						formPages && formPageButtons.forEach((formPageButton)=> {
							formPageButton.addEventListener("click", (event) => {
								event.preventDefault()

								// Close all pages
								let activePage 		= this.modalContent.querySelector('.form-page--active')
								activePage.classList.remove('form-page--active')

								// Find and show only active page from data attribute
								let targetPageID		= event.target.dataset.formpagelink
								let targetPage 		= this.modalContent.querySelector(`[data-formpage="${targetPageID}"]`)
								targetPage.classList.add('form-page--active')

								// Update form page indicator
								let formPageIndicator = this.modalContent.querySelector('.form-page-indicator__num')
								formPageIndicator.innerHTML = targetPageID
							})
						})

						if(data['name'] === 'share-collection' || data['name'] === 'share-collection-email') {
							document.querySelector('#modal__shell').classList.add('modal--large');
							document.getElementById("shareCollectionId").value = modalOpener.dataset.collectionid;
						}

						if(data['name'] === 'share-collection-link') {
							let collectionID = modalOpener.dataset.collectionid; 
							let collectionURL = window.location.hostname + '/browse/?collectionID=' + collectionID;
							document.getElementById('copyPageURL').value = collectionURL;
						}

						if(data['name'] === 'social-shares') {
							if(assetID) {
								let assetURL = window.location.hostname+'/video/appendix/?id='+assetID;
								document.getElementById('copyPageURL').value = assetURL;
							}
						}

						// If modal has a specified size, assign the relevant class
						if(modalOpener.dataset.modalsize) {
							this.modalShell.classList.add('modal--'+modalOpener.dataset.modalsize);
						}

						// Get close buttons again after modal on page
						this.getCloseButtons();

						document.body.classList.add('modal--open');

						if(window.app.smoother) {
							window.app.smoother.paused(true)
						}

						document.body.classList.add("loaded");

						document.getElementById('modal__shell').click();

						hideOnClickOutside( this.modal, 'modal--open' )
					}
				})
			}
		})
	}
	getCloseButtons(){
		this.modalCloseButtons 	= this.modal.querySelectorAll('.modal--close');
		this.modalCloseButtons && this.modalCloseButtons.forEach( (modalCloseButton) => {
			modalCloseButton.addEventListener("click", (event) => {
				event.preventDefault();
				document.body.classList.remove("modal--open");
				setTimeout(() => {
					this.modalContent.innerHTML = '';
					this.modalShell.className = '';
					this.modalShell.classList.add('modal');
				}, 250);

				if(window.app.smoother) {
					window.app.smoother.paused(false);
				}
			})
		})
	}
}
